import React from 'react';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import amplitude from 'amplitude-js';
import { AMPLITUDE_ID } from 'services/analytics';
import App from './App';
import reportWebVitals from './reportWebVitals';
// eslint-disable-next-line import/extensions
import awsconfig from './aws-exports.js';

Amplify.configure(awsconfig, {
  // v6 sends the access token to AppSync by default, but our @auth owner rules
  // (e.g. ForeignNational's custom:person_id) rely on claims that only exist in
  // the ID token. Force the ID token so those rules resolve correctly.
  API: {
    GraphQL: {
      headers: async () => {
        const { tokens } = await fetchAuthSession();
        const idToken = tokens?.idToken?.toString();

        return idToken ? { Authorization: idToken } : {};
      },
    },
  },
});
amplitude.getInstance().init(AMPLITUDE_ID);

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container "#root" was not found.');
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
